import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards ";

export default function IsleManJurisdiction() {

    return (
        <main className='main'>
            <IntroSection
                title="Isle of Man as a Jurisdiction"
                subtitle="A Tier-1 IFC for Banking, Insurance, Funds & iGaming"
                description=
                    "
                    The Isle of Man, a self-governing British Crown Dependency, is one of the most respected offshore jurisdictions worldwide. Known for its political stability, strong regulatory framework, and tax advantages, the Isle of Man is home to leading institutions in banking, insurance, investment funds, fintech, and iGaming.
                    <br/>
                    It is regulated by the Isle of Man Financial Services Authority (IOMFSA) and the Gambling Supervision Commission (GSC), ensuring high standards of compliance, AML/KYC, and consumer protection.
                    "
                badges={[
                    "Banking",
                    "Insurance",
                    "Funds",
                    "FinTech",
                    "iGaming"
                ]}
                buttonText="Request an Isle of Man Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/jurisdictions/isle-of-man-jurisdiction.png')}
                imageAlt="Isle of Man Offshore Jurisdiction"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Choose the Isle of Man?"
                        blocks={[
                            {
                                items: [
                                    { text: "Tier-1 Credibility — trusted by banks, regulators, and institutional investors." },
                                    { text: "Respected Regulators — IOMFSA (finance) & GSC (gaming)." },
                                    { text: "Tax Efficiency — 0% corporate tax, no capital gains tax." },
                                    { text: "Reputation — OECD-compliant, strong global recognition." },
                                    { text: "Innovation — fintech, e-gaming, and blockchain-friendly environment." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Key Sectors in the Isle of Man"
                        blocks={[
                            {
                                title: "Banking & Wealth Management",
                                items: [
                                    { text: "Leading global banks operate in the IoM." },
                                    { text: "Private banking, wealth management, and custody solutions." }
                                ]
                            },
                            {
                                title: "Insurance & Captives",
                                items: [
                                    { text: "Major center for captive insurance and reinsurance." },
                                    { text: "Wide range of general and life insurance licensing." }
                                ]
                            },
                            {
                                title: "Funds & Asset Management",
                                items: [
                                    { text: "Popular for hedge funds, private funds, and UCITS-equivalent structures." },
                                    { text: "Recognized by institutional investors." }
                                ]
                            },
                            {
                                title: "iGaming & Betting",
                                items: [
                                    { text: "The Isle of Man is a top iGaming jurisdiction, regulated by the Gambling Supervision Commission (GSC)." },
                                    { text: "Licenses are globally recognized and highly prestigious." }
                                ]
                            },
                            {
                                title: "FinTech & Blockchain",
                                items: [
                                    { text: "Early adopter of blockchain regulation." },
                                    { text: "Home to crypto exchanges, tokenized assets, and PSPs." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Benefits of the Isle of Man"
                        blocks={[
                            {
                                items: [
                                    { text: "Global Reputation — Tier-1, unlike Seychelles or SVG." },
                                    { text: "Strong Legal Framework — English common law system." },
                                    { text: "Banking Access — excellent relationships with global banks." },
                                    { text: "Investor Confidence — suitable for institutional capital." },
                                    { text: "Innovation-Friendly — progressive with fintech and gaming." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Limitations"
                        blocks={[
                            {
                                items: [
                                    { text: "Higher Costs — setup and licensing fees significantly higher than SVG or Curaçao." },
                                    { text: "More Compliance — strict AML/KYC and ongoing reporting." },
                                    { text: "Not Entry-Level — better suited for established businesses, not startups." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Why Offshore Advisory?"
                        blocks={[
                            {
                                items: [
                                    { text: "Guidance on banking, insurance, funds, and iGaming licensing." },
                                    { text: "Comparative insights: Isle of Man vs Malta vs Gibraltar vs Mauritius." },
                                    { text: "End-to-end support: incorporation, licensing, compliance, and banking." },
                                    { text: "Long-term advisory for maintaining Tier-1 status." }
                                ]
                            }
                        ]}
                    />


                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for a Tier-1 offshore jurisdiction?"
                        description="The Isle of Man offers globally respected licensing in banking, insurance, funds, fintech, and iGaming."
                        buttonText="Book an Isle of Man Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Why the Isle of Man over Malta?",
        answer: "The Isle of Man has equal or higher prestige, stronger UK alignment, and is less politically exposed.",
    },
    {
        question: "Does the Isle of Man tax offshore companies?",
        answer: "No — corporate tax is 0% (except for banking and land-related activities).",
    },
    {
        question: "Is the Isle of Man good for gaming?",
        answer: "Yes — it is one of the most prestigious iGaming regulators in the world.",
    },
    {
        question: "Is it expensive?",
        answer: "Yes — licensing and incorporation are Tier-1 level costs, but bring Tier-1 recognition.",
    },
    {
        question: "Who should use IoM?",
        answer: "Established brokers, funds, insurers, and iGaming companies looking for credibility and access to institutional clients.",
    },
];

const testimonialsData = [
    {
        quote: "Our hedge fund chose the Isle of Man for its credibility. Offshore Advisory guided us through the IOMFSA application.",
        author: "Andrew C.",
        role: "Fund Manager"
    },
    {
        quote: "The Isle of Man gaming license gave our casino Tier-1 status. Offshore Advisory handled everything from incorporation to banking.",
        author: "Clara R.",
        role: "iGaming CEO"
    }
];
